document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('#MobileMenu');
  const closeMobileMenu = () => {
    if (!menuButton || !mobileMenu) return;
    menuButton.setAttribute('aria-expanded', 'false');
    mobileMenu.hidden = true;
  };
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    mobileMenu.hidden = open;
  });
  mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobileMenu));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu && !mobileMenu.hidden) {
      closeMobileMenu();
      menuButton?.focus();
    }
  });

  const customProductSelect = document.querySelector('[data-custom-product-select]');
  if (customProductSelect) {
    const contactParams = new URLSearchParams(window.location.search);
    const productHandle = contactParams.get('product');
    const productLabels = {
      'retractable-wave-shade': 'Retractable Wave Shade',
      'eyelet-rectangle-shade': 'Straight-Edge Eyelet Shade',
      'hybrid-ring-rectangle-shade': 'Hybrid-Ring Rectangle Shade',
      'triangle-shade-sail': 'Triangle Shade Sail',
      'rectangle-shade-sail': 'Rectangle Shade Sail',
      'balcony-privacy-screen': 'Balcony Privacy Screen'
    };
    const productLabel = productLabels[productHandle];
    if (productLabel && [...customProductSelect.options].some((option) => option.value === productLabel)) {
      customProductSelect.value = productLabel;
    }
    const topicInput = document.querySelector('[data-contact-topic]');
    const topicLabels = { shipping: 'Shipping question', returns: 'Return request' };
    if (topicInput && topicLabels[contactParams.get('topic')]) topicInput.value = topicLabels[contactParams.get('topic')];

    const standardDimensions = document.querySelector('[data-standard-dimensions]');
    const triangleDimensions = document.querySelector('[data-triangle-dimensions]');
    const measurementDiagrams = [...document.querySelectorAll('[data-measurement-diagram]')];
    const standardInputs = [...(standardDimensions?.querySelectorAll('input') || [])];
    const triangleInputs = [...(triangleDimensions?.querySelectorAll('input') || [])];
    const syncCustomDimensions = () => {
      const selectedHandle = customProductSelect.selectedOptions[0]?.dataset.productHandle;
      const isTriangle = selectedHandle === 'triangle-shade-sail';
      const diagramType = selectedHandle === 'retractable-wave-shade' ? 'wave' : (isTriangle ? 'triangle' : 'rectangle');
      if (standardDimensions) standardDimensions.hidden = isTriangle;
      if (triangleDimensions) triangleDimensions.hidden = !isTriangle;
      standardInputs.forEach((input) => {
        input.disabled = isTriangle;
        input.required = !isTriangle;
      });
      triangleInputs.forEach((input) => {
        input.disabled = !isTriangle;
        input.required = isTriangle;
      });
      measurementDiagrams.forEach((diagram) => {
        diagram.hidden = diagram.dataset.measurementDiagram !== diagramType;
      });
    };
    customProductSelect.addEventListener('change', syncCustomDimensions);
    syncCustomDimensions();
  }

  document.querySelectorAll('[data-visual-choice]').forEach((group) => {
    const select = group.querySelector('select');
    const buttons = [...group.querySelectorAll('[data-choice-value]')];
    const colorSummaryLabel = group.querySelector('[data-color-summary-label]');
    const colorSummarySwatch = group.querySelector('[data-color-summary-swatch]');
    if (!select || !buttons.length) return;

    const syncVisualChoice = () => {
      let selectedButton;
      buttons.forEach((button) => {
        const selected = button.dataset.choiceValue === select.value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
        if (selected) selectedButton = button;
      });
      if (selectedButton && colorSummaryLabel) {
        colorSummaryLabel.textContent = selectedButton.dataset.choiceLabel || selectedButton.dataset.choiceValue;
      }
      if (selectedButton && colorSummarySwatch) {
        const selectedColor = selectedButton.style.getPropertyValue('--swatch');
        colorSummarySwatch.style.setProperty('--summary-swatch', selectedColor);
        const customForm = group.closest('form');
        if (customForm) {
          customForm.style.setProperty('--selected-product-color', selectedColor);
          customForm.style.setProperty('--selected-color-position', selectedButton.dataset.colorPosition || '0%');
          customForm.querySelectorAll('.shape-option-grid [data-choice-value]').forEach((shapeButton) => {
            shapeButton.dataset.previewColorLabel = selectedButton.dataset.choiceLabel || selectedButton.dataset.choiceValue;
          });
        }
      }
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
      select.value = button.dataset.choiceValue;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncVisualChoice();
    }));
    select.addEventListener('change', syncVisualChoice);
    syncVisualChoice();
  });

  const productQuickPreview = document.querySelector('[data-product-quick-preview]');
  const productChoiceGrid = productQuickPreview?.closest('.shape-option-grid');
  if (productQuickPreview && productChoiceGrid) {
    const productButtons = [...productChoiceGrid.querySelectorAll(':scope > [data-choice-value]')];
    const previewTitle = productQuickPreview.querySelector('[data-product-preview-title]');
    const previewColor = productQuickPreview.querySelector('[data-product-preview-color]');
    const previewCard = productQuickPreview.querySelector('.product-quick-preview-card');
    const closeButton = productQuickPreview.querySelector('[data-product-preview-close]');
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    let hoverTimer;
    let pressTimer;
    let pressOrigin;
    let activeButton;
    let previewMode = '';
    let longPressTriggered = false;

    const clearTimers = () => {
      window.clearTimeout(hoverTimer);
      window.clearTimeout(pressTimer);
      hoverTimer = undefined;
      pressTimer = undefined;
    };

    const openProductPreview = (button, mode) => {
      if (!button) return;
      clearTimers();
      activeButton = button;
      previewMode = mode;
      productQuickPreview.style.setProperty('--preview-product-x', button.dataset.productPosition || '0%');
      if (previewTitle) previewTitle.textContent = button.querySelector('.visual-option-copy b')?.textContent?.trim() || button.dataset.choiceValue;
      if (previewColor) previewColor.textContent = button.dataset.previewColorLabel || '';
      productQuickPreview.classList.toggle('is-touch', mode === 'touch');
      productQuickPreview.classList.add('is-open');
      productQuickPreview.setAttribute('aria-hidden', 'false');
      previewCard?.setAttribute('aria-modal', String(mode === 'touch'));
      document.body.classList.toggle('product-preview-open', mode === 'touch');
      if (mode === 'touch') {
        window.setTimeout(() => closeButton?.focus({ preventScroll: true }), 30);
        if ('vibrate' in navigator) navigator.vibrate(12);
      }
    };

    const closeProductPreview = (restoreFocus = false) => {
      clearTimers();
      const buttonToRestore = activeButton;
      productQuickPreview.classList.remove('is-open', 'is-touch');
      productQuickPreview.setAttribute('aria-hidden', 'true');
      previewCard?.setAttribute('aria-modal', 'false');
      document.body.classList.remove('product-preview-open');
      activeButton = undefined;
      previewMode = '';
      if (restoreFocus) buttonToRestore?.focus({ preventScroll: true });
    };

    productButtons.forEach((button) => {
      button.addEventListener('pointerenter', (event) => {
        if (!hoverQuery.matches || event.pointerType === 'touch') return;
        clearTimers();
        hoverTimer = window.setTimeout(() => openProductPreview(button, 'hover'), 200);
      });
      button.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'touch') return;
        window.clearTimeout(hoverTimer);
        if (activeButton === button && previewMode === 'hover') closeProductPreview();
      });
      button.addEventListener('focus', () => {
        if (!hoverQuery.matches) return;
        hoverTimer = window.setTimeout(() => openProductPreview(button, 'hover'), 150);
      });
      button.addEventListener('blur', () => {
        window.clearTimeout(hoverTimer);
        if (activeButton === button && previewMode === 'hover') closeProductPreview();
      });
      button.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        clearTimers();
        longPressTriggered = false;
        pressOrigin = { x: event.clientX, y: event.clientY };
        pressTimer = window.setTimeout(() => {
          longPressTriggered = true;
          openProductPreview(button, 'touch');
        }, 520);
      });
      button.addEventListener('pointermove', (event) => {
        if (!pressOrigin || event.pointerType === 'mouse') return;
        if (Math.hypot(event.clientX - pressOrigin.x, event.clientY - pressOrigin.y) > 12) {
          window.clearTimeout(pressTimer);
          pressOrigin = undefined;
        }
      });
      ['pointerup', 'pointercancel'].forEach((eventName) => button.addEventListener(eventName, () => {
        window.clearTimeout(pressTimer);
        pressTimer = undefined;
        pressOrigin = undefined;
      }));
      button.addEventListener('click', (event) => {
        if (!longPressTriggered) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        longPressTriggered = false;
      }, true);
      button.addEventListener('contextmenu', (event) => {
        if (previewMode === 'touch' || pressTimer) event.preventDefault();
      });
    });

    closeButton?.addEventListener('click', () => closeProductPreview(true));
    productQuickPreview.addEventListener('click', (event) => {
      if (event.target === productQuickPreview && previewMode === 'touch') closeProductPreview(true);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && productQuickPreview.classList.contains('is-open')) closeProductPreview(true);
    });
  }

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input');
    if (!input) return;
    const clampQuantity = (value) => {
      const minimum = Number(input.min || 1);
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      return Math.min(maximum, Math.max(minimum, Math.round(Number(value) || minimum)));
    };
    const updateStepButtons = () => {
      const value = clampQuantity(input.value);
      control.querySelectorAll('[data-quantity-step]').forEach((button) => {
        const step = Number(button.dataset.quantityStep || 0);
        const atMinimum = step < 0 && value <= Number(input.min || 1);
        const atMaximum = step > 0 && input.max && value >= Number(input.max);
        button.disabled = Boolean(atMinimum || atMaximum);
        button.setAttribute('aria-disabled', String(button.disabled));
      });
    };
    control.querySelectorAll('[data-quantity-step]').forEach((button) => button.addEventListener('click', () => {
      const step = Number(button.dataset.quantityStep || 0);
      input.value = String(clampQuantity(Number(input.value || input.min || 1) + step));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    input.addEventListener('change', () => {
      input.value = String(clampQuantity(input.value));
      updateStepButtons();
    });
    updateStepButtons();
  });

  const customOrderForm = document.querySelector('#CustomOrderForm');
  const customAddButton = customOrderForm?.querySelector('[data-custom-add-to-cart]');
  if (customOrderForm && customAddButton) {
    const customCartStatus = customOrderForm.querySelector('[data-custom-cart-status]');
    const customButtonLabel = customAddButton.querySelector('span');
    customAddButton.addEventListener('click', async () => {
      const productSelect = customOrderForm.querySelector('[data-custom-product-select]');
      const selectedProduct = productSelect?.selectedOptions?.[0];
      const variantId = Number(selectedProduct?.dataset.variantId || 0);
      const quantity = Math.max(1, Math.round(Number(customOrderForm.querySelector('[data-custom-quantity]')?.value || 1)));
      const width = customOrderForm.querySelector('[data-custom-width]')?.value.trim();
      const length = customOrderForm.querySelector('[data-custom-length]')?.value.trim();
      const sideA = customOrderForm.querySelector('[data-triangle-side="A"]')?.value.trim();
      const sideB = customOrderForm.querySelector('[data-triangle-side="B"]')?.value.trim();
      const sideC = customOrderForm.querySelector('[data-triangle-side="C"]')?.value.trim();
      const isTriangle = selectedProduct?.dataset.productHandle === 'triangle-shade-sail';
      const color = customOrderForm.querySelector('#CustomColorChoice')?.value;
      const unit = customOrderForm.querySelector('[data-custom-unit]')?.value;
      const installationArea = customOrderForm.querySelector('[data-custom-installation]')?.value;
      const photoLink = customOrderForm.querySelector('[data-custom-photo-link]')?.value.trim();
      const notes = customOrderForm.querySelector('[data-custom-notes]')?.value.trim();
      if (!variantId) {
        if (customCartStatus) customCartStatus.textContent = customAddButton.dataset.errorLabel;
        return;
      }
      if (isTriangle && (!sideA || !sideB || !sideC)) {
        if (customCartStatus) customCartStatus.textContent = customAddButton.dataset.dimensionErrorLabel;
        customOrderForm.querySelector('[data-triangle-side]:invalid')?.focus();
        return;
      }
      if (!isTriangle && (!width || !length)) {
        if (customCartStatus) customCartStatus.textContent = customAddButton.dataset.standardDimensionErrorLabel;
        const missingStandardInput = [...customOrderForm.querySelectorAll('[data-standard-dimensions] input')]
          .find((input) => !input.value.trim());
        missingStandardInput?.focus();
        return;
      }

      const properties = {
        '_Custom request': 'Yes',
        '_Estimated delivery time': '15–20 days from order',
        'Starting form': selectedProduct.value
      };
      if (unit) properties['Measurement unit'] = unit;
      if (installationArea) properties['Installation area'] = installationArea;
      if (isTriangle) {
        properties['Side A'] = sideA;
        properties['Side B'] = sideB;
        properties['Side C'] = sideC;
      } else {
        if (width) properties.Width = width;
        if (length) properties.Length = length;
      }
      if (color) properties['Preferred color'] = color;
      if (photoLink) properties['Photo / drawing link'] = photoLink;
      if (notes) properties['Project notes'] = notes;

      customAddButton.disabled = true;
      if (customButtonLabel) customButtonLabel.textContent = customAddButton.dataset.loadingLabel;
      if (customCartStatus) customCartStatus.textContent = '';
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity, properties }] })
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cartResponse = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.bag-link span').forEach((count) => {
            count.textContent = String(cart.item_count);
          });
        }
        customAddButton.disabled = false;
        if (customCartStatus) customCartStatus.textContent = customAddButton.dataset.successLabel;
        if (customButtonLabel) customButtonLabel.textContent = customAddButton.dataset.idleLabel;
      } catch (error) {
        customAddButton.disabled = false;
        if (customButtonLabel) customButtonLabel.textContent = customAddButton.dataset.idleLabel;
        if (customCartStatus) customCartStatus.textContent = customAddButton.dataset.errorLabel;
      }
    });
  }

  const root = document.querySelector('[data-product-root]');
  if (!root) return;
  const mainImage = root.querySelector('[data-main-image]');
  const dialog = document.querySelector('[data-image-dialog]');
  const dialogImage = dialog?.querySelector('img');
  let variants = [];
  try {
    variants = JSON.parse(root.querySelector('[data-variants]')?.textContent || '[]');
  } catch (error) {
    variants = [];
  }
  const optionSelects = [...root.querySelectorAll('[data-option-index]')];
  const variantInput = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-price]');
  const currency = root.dataset.currency || 'USD';

  const addButton = root.querySelector('.add-button');
  const addButtonLabel = addButton?.querySelector('[data-add-label]');
  let imageSwapToken = 0;

  const setMainImage = (src) => {
    if (!mainImage || !src) return;
    const normalizedSrc = new URL(src, window.location.href).href;
    if (mainImage.src === normalizedSrc) return;
    const currentToken = ++imageSwapToken;
    mainImage.classList.add('is-loading');
    const preload = new Image();
    const commit = () => {
      if (currentToken !== imageSwapToken) return;
      mainImage.src = normalizedSrc;
      mainImage.classList.remove('is-loading');
    };
    preload.addEventListener('load', commit, { once: true });
    preload.addEventListener('error', () => {
      if (currentToken === imageSwapToken) mainImage.classList.remove('is-loading');
    }, { once: true });
    preload.src = normalizedSrc;
    if (preload.complete && preload.naturalWidth) commit();
  };

  const selectVariant = () => {
    const selected = optionSelects.map((select) => select.value);
    const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
    if (!variant) {
      if (addButton) addButton.disabled = true;
      return;
    }
    variantInput.value = variant.id;
    price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(variant.price / 100);
    if (price) price.setAttribute('aria-label', price.textContent);
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.setAttribute('aria-disabled', String(!variant.available));
      if (addButtonLabel) addButtonLabel.textContent = variant.available ? addButton.dataset.idleLabel : addButton.dataset.soldOutLabel;
    }
    const variantUrl = new URL(window.location.href);
    variantUrl.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', variantUrl);
  };

  root.querySelectorAll('.gallery-thumb').forEach((button) => button.addEventListener('click', () => {
    root.querySelectorAll('.gallery-thumb').forEach((item) => {
      item.classList.remove('active');
      item.setAttribute('aria-pressed', 'false');
    });
    button.classList.add('active');
    button.setAttribute('aria-pressed', 'true');
    setMainImage(button.dataset.galleryImage);
  }));

  root.querySelectorAll('.swatch').forEach((button) => {
    const preloadColorImage = () => {
      if (!button.dataset.colorImage || button.dataset.preloaded === 'true') return;
      button.dataset.preloaded = 'true';
      const preload = new Image();
      preload.src = button.dataset.colorImage;
    };
    button.addEventListener('pointerenter', preloadColorImage, { once: true });
    button.addEventListener('focus', preloadColorImage, { once: true });
    button.addEventListener('click', () => {
      root.querySelectorAll('.swatch').forEach((item) => {
        item.classList.remove('selected');
        item.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('selected');
      button.setAttribute('aria-pressed', 'true');
      const colorSelect = root.querySelector('.color-option select');
      const colorValue = button.dataset.colorValue;
      if (colorSelect && colorValue && [...colorSelect.options].some((option) => option.value === colorValue)) {
        colorSelect.value = colorValue;
      }
      const currentColor = root.querySelector('[data-current-color]');
      if (currentColor) currentColor.textContent = button.getAttribute('aria-label') || button.textContent.trim();
      root.querySelectorAll('.gallery-thumb').forEach((item) => {
        item.classList.remove('active');
        item.setAttribute('aria-pressed', 'false');
      });
      setMainImage(button.dataset.colorImage);
      selectVariant();
    });
  });
  optionSelects.forEach((select) => select.addEventListener('change', selectVariant));

  root.querySelector('.product-form')?.addEventListener('submit', () => {
    if (!addButton || addButton.disabled) return;
    addButton.disabled = true;
    addButton.setAttribute('aria-busy', 'true');
    if (addButtonLabel) addButtonLabel.textContent = addButton.dataset.loadingLabel;
  });
  window.addEventListener('pageshow', () => {
    if (!addButton) return;
    addButton.removeAttribute('aria-busy');
    selectVariant();
  });
  selectVariant();

  const openDialog = (src) => { if (!dialog || !dialogImage) return; dialogImage.src = src; dialog.showModal(); };
  root.querySelector('[data-zoom]')?.addEventListener('click', () => openDialog(mainImage.src));
  mainImage?.addEventListener('click', () => openDialog(mainImage.src));
  mainImage?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openDialog(mainImage.src);
    }
  });
  root.querySelectorAll('[data-detail-image]').forEach((button) => button.addEventListener('click', () => openDialog(button.dataset.detailImage)));
  dialog?.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
});
